import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import store from "@services/Redux";
import { CookiesProvider } from "react-cookie";

import Analytics from "@components/Analytics";

ReactDOM.render(
  <CookiesProvider>
    <Provider store={store}>
      <BrowserRouter>
        <App />
        <Analytics />
      </BrowserRouter>
    </Provider>
  </CookiesProvider>,
  document.getElementById("root")
);
